import React from 'react';
import './auth-ui.css';

const AuthBootScreen: React.FC = () => (
  <div className="auth-boot">
    <div className="auth-boot-card">
      <img src="/mockloc-icon.png" alt="" className="auth-boot-logo" />
      <div className="auth-boot-spinner" aria-hidden="true" />
      <p className="auth-boot-text">Loading your session…</p>
    </div>
  </div>
);

export default AuthBootScreen;
